import { useMemo, useRef } from 'react';
import isEqual from 'lodash/isEqual';

import type { Filter } from 'Types/filter';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

import type { UseVehicleListQuery } from './useVehicleListQuery/useVehicleListQuery';

interface UseShouldFetchMakeModelCount {
	filters: Filter;
	vehicleListQuery: UseVehicleListQuery;
}

export const useShouldFetchMakeModelCount = ({ filters, vehicleListQuery }: UseShouldFetchMakeModelCount): boolean => {
	const prevFilter = useRef<Filter>();
	const isVehicleListDisabled = useFeatureToggle(FEATURES.showDownloadCSVButtonOutsideList);

	const shouldFetchCountBasedOnFilters = useMemo(() => {
		const isInitial = !prevFilter?.current;

		const isMakeEqual = isEqual(prevFilter.current?.make, filters.make);
		const isModelEqual = isEqual(prevFilter.current?.model, filters.model);
		const isMakeOrModelFilterChanged = !isMakeEqual || !isModelEqual;

		if (!isInitial) {
			prevFilter.current = filters;
		}

		return isInitial || !isMakeOrModelFilterChanged;
	}, [filters]);

	if (isVehicleListDisabled) return false;
	if (!vehicleListQuery.filterQuery) return false;

	return shouldFetchCountBasedOnFilters;
};
